import { Box, Typography } from '@mui/material'
import SettingsBox from './SettingsBox'

interface SchoolInformationSettingsProps {
  schoolName: string
  address: string
}

function SchoolInformationSettings({ schoolName, address }: SchoolInformationSettingsProps) {
  return (
    <SettingsBox title='School Information'>
      <Box sx={{ my: 1 }}>
        <Typography variant='subtitle1' color='textSecondary'>
          School Name
        </Typography>
        <Typography variant='body1'>{schoolName}</Typography>
      </Box>
      <Box sx={{ my: 1 }}>
        <Typography variant='subtitle1' color='textSecondary'>
          Address
        </Typography>
        <Typography variant='body1'>{address}</Typography>
      </Box>
    </SettingsBox>
  )
}

export default SchoolInformationSettings
